import React from 'react';
import PropTypes from 'prop-types';
import Container from './Container';

const DialogHeader = ({ children, ...props }) => (
  <Container
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    minHeight="55px"
    padding="0 16px"
    {...props}
  >
    {children}
  </Container>
);

DialogHeader.propTypes = {
  children: PropTypes.node,
};

DialogHeader.defaultProps = {
  children: null,
};

export default DialogHeader;
